import React, { useState, useEffect } from "react";
// components
import Button from "../Button";

// assets
import deleteModalIconImg from "img/delete-modal-icon.svg";
//styles
import { Image, CustomImage, CustomButton, TextBtnYes } from "./styles";
import Text from "components/Text";
import Modal from "pages/Quotes/components/generics/Modal";

interface IConfirmExclusionSKU {
  setModalResponse?: (response: boolean) => void;
}

const ConfirmExclusionSKU = ({ setModalResponse }: IConfirmExclusionSKU) => {
  const handleCancel = () => {
    if (setModalResponse) {
      setModalResponse(false);
    }
  };

  const handleConfirm = () => {
    if (setModalResponse) {
      setModalResponse(true);
    }
  };

  return (
    <Modal width={"350px"} alignButtons={"center"} gap={"20px"}>
      <Image>
        <CustomImage src={deleteModalIconImg} alt="alert icon" />
      </Image>
      <div className="message">
        <Text className="color-blue-gray font-bold" size={16}>
          {"Confirmar exclusão?"}
        </Text>
      </div>
      <div className="message">
        {
          "Tem certeza que deseja excluir o(s) item(ns) selecionado(s)? Esta ação não pode ser desfeita."
        }
      </div>
      <div className="buttons">
        <CustomButton className="btnYes">
          <Button
            second
            label={<TextBtnYes>Excluir</TextBtnYes>}
            onClick={handleConfirm}
            className="bg-greenDarkViveo"
          />
        </CustomButton>
        <CustomButton className="btnNo">
          <Button second label="Cancelar" onClick={handleCancel} />
        </CustomButton>
      </div>
    </Modal>
  );
};

export default ConfirmExclusionSKU;
